import { makeAutoObservable } from 'mobx';
import {DomainStore} from 'shared/store';
import _ from 'lodash';

class TimeOffState {
  store = new DomainStore();
  emojiReady;

  accounts = [];

  constructor() {
    makeAutoObservable(this, {
      store: false,
      emojiReady: false
    });
  }

  receiveProps({accounts, emojiReady}) {
    this.accounts = accounts;
    this.emojiReady = emojiReady;
  }

  get sortedAccounts() {
    return _.orderBy(this.accounts, 'timeOffType.order');
  }
}

export default TimeOffState;
